<template>
  <date-range-picker
                ref="picker"
                :opens="'left'"
                :locale-data="{ firstDay: 1, format: 'dd-mm-yyyy HH:mm:ss' }"
                :minDate="minDate" 
                :maxDate="maxDate"
                :showWeekNumbers="true"
                :showDropdowns="true"
                :autoApply="true"
                :disabled="disabled"
                :readonly="readOnly"
                v-model="dateRange"
                @update="updateValues"
                :alwaysShowCalendars="false"
      >
      <template  v-slot:input="picker" :id="id" :name="name">
        <b-row align-h="end">
          <b-col cols="10 pl-3">{{picker.startDate ? dayjs(picker.startDate).format("DD-MM-YYYY")+" - "+dayjs(picker.endDate).format("DD-MM-YYYY") : placeholder}}</b-col>
          <b-col cols="1 pr-4"><i class="icon fa fa-sort datepicker-icon-text" aria-hidden="true"></i></b-col>
        </b-row>
      </template>
      </date-range-picker>
</template>

<script>
import Vue from 'vue';
import "../../assets/scss/input.scss";
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import "../../assets/scss/date-range-picker.scss";

const dayjs = require("dayjs");

Vue.component('DateRangePicker', DateRangePicker)

export default {
  name: "my-date-range-picker",
  data() {
    return {
      text: this.$props.defaultText,
      dateRange: {
        startDate: null,
        endDate: null
      }
    };
  },
  methods: {
    updateValues() {
      this.$emit("update", this.dateRange);
    }
  },
  props: {
    minDate: {
      type: Date,
      default: null
    },
    maxDate: {
      type: Date,
      default: () => { return new Date() }
    },
    id: {
      //required: true,
    },
    name: {
      type: String,
      //required: true,
    },
    label: {
      type: String,
      required: false,
    },
    placeholder: {
      required: false,
      default: ''
    },
    mandatory: {
      // type: Boolean,
      default: false,
    },
    readOnly: {
      default: null,
    },
    disabled: {
      default: false,
    },
    error: {
      type: String,
      default: "",
    },
  },

  computed: {
    dayjs() {
      return dayjs;
    }
  },

  components: [
    DateRangePicker
  ]
};
</script>
